import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom'

import '../assets/styles/ItemInfoCanva.css'
export default function ItemInfoCanva(props) {

    const hexToRgba = (hex, alpha) => {
        hex = hex.replace(/^#/, '');

        if (hex.length === 3) {
            hex = hex.split('').map(x => x + x).join('');
        }

        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    return (
        <div className="itemInfoCanva">
            <Offcanvas
                className="item-info-canva"
                data-bs-theme="dark"
                scroll={true}
                backdrop={false}
                show={props.itemInfoCanvaVisible}
                onHide={() => props.setItemInfoCanvaVisible(false)}
                {...props}
            >                
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className='title fw-bold'>Item Info</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className='d-flex align-items-center flex-column'>
                    <div className='text-light text-center item-name fw-bold'>
                        {props.canvaItemInfo.name}
                    </div>
                    <img className='mt-5' src={props.canvaItemInfo.image} />
                    <div className='text-light rarity mt-5 rarity-name' style={{ backgroundColor: `${hexToRgba('#' + props.canvaItemInfo.rarityColor, 1)}` }}>
                        {props.canvaItemInfo.rarityName}
                    </div>
                    {
                        props.canvaItemInfo.heroName !== null ?
                            <div className='mt-5 text-light fs-5 w-100 d-flex align-items-center w-100 mt-2 slot'>
                                <div className='tag ms-2 fw-bold fs-4 me-2'>Hero</div><span className="hero-name">: {props.canvaItemInfo.heroName}</span>
                            </div>
                            :
                            ""
                    }
                    {
                        props.canvaItemInfo.slot !== null ?
                            <div className='text-light fs-5 w-100 d-flex align-items-center w-100 mt-2 slot'>
                                <div className='tag ms-2 fw-bold fs-4 me-2'>Slot</div><span className="item-slot">: {props.canvaItemInfo.slot}</span>
                            </div>
                            :
                            ""
                    }
                    <div className='text-light fs-5 w-100 d-flex align-items-center w-100 mt-2 slot'>
                        <div className='tag ms-2 fw-bold fs-4 ms-0 me-2'>Price</div><span className="item-price">: {props.canvaItemInfo.priceSafe} $</span>
                    </div>
                    <div className=' w-100 d-flex align-items-center justify-content-center mt-5 item-links'>
                        <Link className="me-3" target="_blank" rel="noopener noreferrer" to={props.canvaItemInfo.steamUrl}>
                            <i className="text-light bi bi-steam"></i>
                        </Link>
                        <Link target="_blank" rel="noopener noreferrer" to={`https://steamcommunity.com/profiles/${props.steamid}/inventory/#570_2_${props.canvaItemInfo.assetId}`}>
                            <i className="text-light bi bi-box-seam-fill"></i>
                        </Link>
                    </div>


                </Offcanvas.Body>
            </Offcanvas>
        </div>
    )
}